/**
 * L'Épure Maison — reliable cart drawer actions.
 * Theme test only. Never redirect to /cart from openCart.
 */
function configureCartActions() {
  const actions = window.Shopify?.actions;
  if (!actions?.openCart?.configure || !actions?.updateCart?.configure) return false;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (!drawer) {
        console.warn('[L’Épure Maison] Cart drawer markup unavailable; no redirect performed.');
        return;
      }
      if (typeof drawer.open !== 'function') {
        await customElements.whenDefined('theme-drawer');
      }
      drawer.open();
    },
  });
  return true;
}

if (!configureCartActions()) {
  document.addEventListener('DOMContentLoaded', () => {
    if (configureCartActions()) return;
    let attempts = 0;
    const retry = setInterval(() => {
      attempts++;
      if (configureCartActions() || attempts >= 30) clearInterval(retry);
    }, 100);
  }, { once: true });
}
